export default "__VITE_ASSET__B1ZQpnVr__"